export const SENTRY_KEYS = {
  CRM_SEARCH_ERROR: 'CRM_SEARCH_ERROR',
  NON_CRM_OBJECT_ERROR: 'NON_CRM_OBJECT_ERROR',
  CRM_PROPERTIES_ERROR: 'CRM_PROPERTIES_ERROR',
  CRM_TYPE_DEFINITION_ERROR: 'CRM_TYPE_DEFINITION_ERROR',
  CRM_OBJECT_NOT_FOUND: 'CRM_OBJECT_NOT_FOUND',
  ERROR_BOUNDARY: 'ERROR_BOUNDARY',
  GENERIC_ERROR: 'GENERIC_ERROR',
  PREVIEW_COMPONENT_NOT_FOUND: 'PREVIEW_COMPONENT_NOT_FOUND',
  SOCIAL_BROADCAST_SOCIAL_ICON: 'SOCIAL_BROADCAST_SOCIAL_ICON',
  TOP_LEVEL_SIDEPANEL_PREVIEW: 'TOP_LEVEL_SIDEPANEL_PREVIEW',
  TOP_LEVEL_POPOVER_PREVIEW: 'TOP_LEVEL_POPOVER_PREVIEW',
  TOP_LEVEL_ASSETS_TAB: 'TOP_LEVEL_ASSETS_TAB',
  ASSOCIATED_OBJECTS: 'ASSOCIATED_OBJECTS',
  PERFORMANCE_TAB: 'PERFORMANCE_TAB',
  CUSTOM_TAB: 'CUSTOM_TAB'
};
export const IGNORE_ERRORS = [
// This happens when you name/rename a campaign to a value that has already been
// taken by a previous campaign.
// In this case we display a notification to the user.
// Since we need to submit the changes to the backend to check for a naming conflict,
// and the correct http status for this is 409
// the api error is unavoidable.
// That said, getting this error is WAD
'Campaign with this name already exists'];